import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import SourceStatusesService from "services/SourceStatus";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
});

function SourceStatusForm({ model, onSuccess }) {
  const handleSubmit = async values => {
    const data = { name: values.name };
    if (model?.id) {
      await SourceStatusesService.edit(model.id, data);
    } else {
      await SourceStatusesService.create(data);
    }
    toast.success("Source Status saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ name: model?.name ?? "" }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required autoFocus />
    </BaseForm>
  );
}

export default SourceStatusForm;
